import {CardBrand} from "@app/core/payment-method/application/card-brand";
import {StoredCardDTO} from "@app/core/payment-method/application/stored-card-dto";

export class StoredCardDTOMapper {

    private static readonly KEY = {
        ID: 'id',
        BRAND: 'brand',
        EXPIRY_MONTH: 'expiryMonth',
        EXPIRY_YEAR: 'expiryYear',
        LAST_FOUR_DIGITS: 'lastFourDigits',
    }

    private static readonly cardBrandMapping: Record<string, CardBrand> = {
        VISA: CardBrand.VISA,
        MASTERCARD: CardBrand.MASTERCARD,
        AMERICAN_EXPRESS: CardBrand.AMERICAN_EXPRESS,
        MAESTRO: CardBrand.MAESTRO,
    }

    map(params: Record<string, any>): StoredCardDTO {
        const brandType = StoredCardDTOMapper.cardBrandMapping[<string>params[StoredCardDTOMapper.KEY.BRAND]] ?? CardBrand.OTHER;
        return new StoredCardDTO({
            id: <string>params[StoredCardDTOMapper.KEY.ID],
            brand: brandType,
            expiryMonth: <string>params[StoredCardDTOMapper.KEY.EXPIRY_MONTH],
            expiryYear: <string>params[StoredCardDTOMapper.KEY.EXPIRY_YEAR],
            lastFourDigits: <string>params[StoredCardDTOMapper.KEY.LAST_FOUR_DIGITS],
        });
    }

}